import { configureStore } from "@reduxjs/toolkit";
import mapSlice from "./mapSlice";
import filterSlice from "./filterSlice";
import placeSlice from "./placeSlice";
import userSlice from "./userSlice";
import modalSlice from "./modalSlice";

export const { setMapBounds, setMapZoom, setMapCenter, setActiveMarkerId } =
  mapSlice.actions;

export const {
  setFilterAcceptsReservations,
  setFilterHasWineGlasses,
  setFilterOpenNow,
  setFilterPrice,
} = filterSlice.actions;

export const {
  setPlaces,
  setHighlightedPlaceId,
  setEditPlaceId,
  setViewPlaceId,
} = placeSlice.actions;

export const {
  setShowSignupModal,
  setSignupModalView,
  setEmailSignupModalView,

  setShowCreatePlaceModal,
  setShowEditPlaceModal,
  setShowViewPlaceModal,
  setShowCreateProfileModal,
  setShowEditProfileModal,
} = modalSlice.actions;

export const { setProfile, clearProfile } = userSlice.actions;

const store = configureStore({
  reducer: {
    map: mapSlice.reducer,
    filter: filterSlice.reducer,
    place: placeSlice.reducer,
    modal: modalSlice.reducer,
    user: userSlice.reducer,
  },
});

export default store;
